
import { PaymentApiPayrollemployeekjarniListRequest, PayrollEmployeeKjarni } from '@/api/openapi';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { paginationMixin, paginationPersistenceMixin, parsePagination } from '@/utils';
import Pagination from '../Pagination.vue';
import PayrollEmployeeFilters from './PayrollEmployeeFilters.vue';

// @ts-ignore
@Component({
  components: { PayrollEmployeeFilters, Pagination },
  mixins: [paginationMixin, paginationPersistenceMixin],
})
export default class PayrollEmployeesKjarni extends Vue {
  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;
  @Getter loggedInUserHasAnyPermission: any;

  // Declare mixin properties and methods for TypeScript
  currentPage!: number;
  currentLimit!: number;
  loadPaginationOptions!: () => void;
  savePaginationOptions!: () => void;
  changePageWithPersistence!: (page: number) => void;
  changeLimitWithPersistence!: (limit: number) => void;
  getGlobalIndex!: (localIndex: number, pagination: any) => number;

  // Set the pagination key
  paginationKey = 'payrollEmployeesKjarni';

  data: Array<PayrollEmployeeKjarni & { isChecked: boolean; isSubmitting: boolean; isCreated: boolean; isError: boolean }> | null = null;
  loading = true;
  submitting = false;
  pagination: any = null;

  search: PaymentApiPayrollemployeekjarniListRequest = {
    placementGroup: undefined,
    period: undefined,
    periodPart: undefined,
    workplace: undefined,
    workplaceType: undefined,
    exists: undefined,
  };

  @Watch('search', { deep: true })
  onSearchChanged() {
    this.currentPage = 1; // Reset to first page when search changes
    this.savePaginationOptions();
    this.loadData(this.currentPage, this.currentLimit);
  }

  get allSelected() {
    return (this.data || []).every(a => a.isChecked);
  }

  get someSelected() {
    return (this.data || []).some(a => a.isChecked);
  }

  async loadData(page = 1, limit = 100) {
    const currentPage = page || this.currentPage;
    const currentLimit = limit || this.currentLimit;

    this.loading = true;

    try {
      const response = await this.$paymentApi.payrollemployeekjarniList({
        period: this.search.period ? this.search.period : undefined,
        periodPart: this.search.periodPart ? this.search.periodPart : undefined,
        placementGroup: this.search.placementGroup ? this.search.placementGroup : undefined,
        workplace: this.search.workplace ? this.search.workplace : undefined,
        workplaceType: this.search.workplaceType ? this.search.workplaceType : undefined,
        exists: this.search.exists ? this.search.exists : undefined,
        page: currentPage,
        limit: currentLimit,
      });

      this.data = response.data.map(d => ({ isChecked: false, isSubmitting: false, isCreated: false, isError: false, ...d }));
      this.pagination = parsePagination(response);
    } catch (e) {
      this.data = [];
      this.$log.error(e);
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.loading = false;
    }
  }

  apiErrorMessage(e: any): string {
    if (e?.response?.status === 400) return 'Gögnin eru ekki í samræmi við Kjarna. Vinsamlegast yfirfarið stillingar á launaflokkum.';
    return 'Óvænt villa kom upp. Vinsamlegast reyndu aftur.';
  }

  async createInKjarni(emp: PayrollEmployeeKjarni) {
    if (this.search.period) {
      this.submitting = true;

      try {
        await this.$paymentApi.createInKjarni({
          period: this.search.period,
          person: emp.id,
        });

        this.displaySuccess(`Starfsmaðurinn „${emp.name}” hefur verið stofnaður.`);

        this.loadData(this.currentPage, this.currentLimit);
      } catch (e) {
        this.$log.error(e);
        this.displayError(this.apiErrorMessage(e));
      } finally {
        this.submitting = false;
      }
    }
  }

  async rehireInKjarni(emp: PayrollEmployeeKjarni) {
    if (this.search.period) {
      this.submitting = true;

      try {
        await this.$paymentApi.rehireInKjarni({
          period: this.search.period,
          person: emp.id,
        });

        this.displaySuccess(`Starfsmaðurinn „${emp.name}” hefur verið endurráðin/n.`);

        this.loadData(this.currentPage, this.currentLimit);
      } catch (e) {
        this.$log.error(e);
        this.displayError(this.apiErrorMessage(e));
      } finally {
        this.submitting = false;
      }
    }
  }

  async runSelected() {
    if (this.data && this.search.period) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i !== this.data.length; i++) {
        const d = this.data[i];
        if (d.isChecked && !d.isCreated && !d.isError) {
          this.data[i].isSubmitting = true;
          try {
            if (d.existsInKjarni) {
              // eslint-disable-next-line no-await-in-loop
              await this.$paymentApi.rehireInKjarni({
                period: this.search.period,
                person: d.id,
              });
            } else {
              // eslint-disable-next-line no-await-in-loop
              await this.$paymentApi.createInKjarni({
                period: this.search.period,
                person: d.id,
              });
            }
            this.data[i].isCreated = true;
          } catch {
            this.data[i].isError = true;
          } finally {
            this.data[i].isChecked = false;
            this.data[i].isSubmitting = false;
          }
        }
      }
    }
  }

  selectAll() {
    if (this.data) {
      this.$set(
        this,
        'data',
        this.data.map(a => ({
          ...a,
          isChecked: !this.allSelected,
        })),
      );

      // this.event.data.attendees[index].isCreated = value;
    }
  }

  rowChecked(index: number, value: boolean) {
    if (this.data) {
      this.data[index].isChecked = value;
    }
  }

  created() {
    this.loadPaginationOptions();
  }
}
